import axios from 'axios';
import SessionStore from './lazyLoaders/session_lazy';

export const axiosBaseURL = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "http://127.0.0.1:8000/",
});

axiosBaseURL.interceptors.request.use((config) => {
  const token =  SessionStore.getToken();;
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

export const getChapterParam = () =>{
  const chapter_id = SessionStore.getChapter()
  if(chapter_id){
    return `chapter_reltn=${chapter_id}`
  }
  return 'chapter_reltn_isnull=True'
}